import React from 'react';
import { motion } from 'framer-motion';
export function MeshGradientBackground() {
  return <div className="fixed inset-0 z-0 overflow-hidden bg-slate-950" data-id="element-91">
      {/* Base gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900 to-slate-950" data-id="element-92" />

      {/* Animated Mesh Blobs */}
      <motion.div className="absolute -top-[20%] -left-[10%] w-[70vw] h-[70vw] rounded-full bg-emerald-500/20 blur-[100px]" animate={{
      x: [0, 100, 0],
      y: [0, 50, 0],
      scale: [1, 1.1, 1]
    }} transition={{
      duration: 20,
      repeat: Infinity,
      repeatType: 'reverse',
      ease: 'easeInOut'
    }} data-id="element-93" />

      <motion.div className="absolute top-[20%] right-[0%] w-[60vw] h-[60vw] rounded-full bg-slate-600/30 blur-[120px]" animate={{
      x: [0, -50, 0],
      y: [0, 100, 0],
      scale: [1, 1.2, 1]
    }} transition={{
      duration: 25,
      repeat: Infinity,
      repeatType: 'reverse',
      ease: 'easeInOut',
      delay: 2
    }} data-id="element-94" />

      <motion.div className="absolute -bottom-[20%] left-[20%] w-[80vw] h-[80vw] rounded-full bg-emerald-900/20 blur-[100px]" animate={{
      x: [0, 50, 0],
      y: [0, -50, 0]
    }} transition={{
      duration: 30,
      repeat: Infinity,
      repeatType: 'reverse',
      ease: 'easeInOut',
      delay: 5
    }} data-id="element-95" />

      {/* Noise overlay for texture */}
      <div className="absolute inset-0 opacity-[0.03] mix-blend-overlay pointer-events-none" style={{
      backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.65%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")'
    }} data-id="element-96" />
    </div>;
}